import { NamedContext, useNamedContext } from "@store/Framework/Components/NamedContext/NamedContext";
import React, { FC, useMemo } from "react";

export interface NamedContextProviderProps {
    value: string;
    children?: React.ReactNode;
}

export const NamedContextProvider: FC<NamedContextProviderProps> = ({ value, children }) => {
    const parentNames = useNamedContext();
    const currentNames = useMemo(() => [value, ...parentNames], [value, parentNames]);

    return <NamedContext.Provider value={currentNames}>{children}</NamedContext.Provider>;
};
